module.exports = __webpack_public_path__ + "img/zhanshiyanghsi.3ffa01aa.png";